import { useEffect, useState } from "react";
import { fmtLiveClockIST } from "../lib/formatDateTime";

// Reusable T-first-ball countdown (DD HH MM) + live IST clock.
// `size` controls the numeric text size class.
export default function CountdownClock({ target, size = "text-2xl md:text-3xl", label = "First Ball" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  if (!target) return null;
  const t = new Date(target).getTime() - now;
  // Before first ball: T-DD HH MM (counting down). After first ball: T+DD HH MM (elapsed).
  const sign = t > 0 ? "-" : "+";
  const abs = Math.abs(t);
  const d = String(Math.floor(abs / 8.64e7)).padStart(2, "0");
  const h = String(Math.floor((abs % 8.64e7) / 3.6e6)).padStart(2, "0");
  const m = String(Math.floor((abs % 3.6e6) / 6e4)).padStart(2, "0");
  return (
    <div className="font-mono-live flex items-center gap-2 flex-wrap" data-testid="dashboard-countdown">
      <span className="mc-label">{label}</span>
      <span className={`${size} font-bold text-readyGreen`}>T{sign}{d}d {h}h {m}m</span>
      <span className="mc-label">IST · {fmtLiveClockIST(now)}</span>
    </div>
  );
}
